import { Box } from '@dtx-company/shared-components/src'
import { space } from 'styled-system'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  display: block;
  text-align: center;
  button:first-child {
    margin-bottom: 20px;
  }
  ${space}
`
